import { render } from "./NotificationExportPane.vue?vue&type=template&id=b78d8d90&scoped=true&ts=true"
import script from "./NotificationExportPane.vue?vue&type=script&lang=ts"
export * from "./NotificationExportPane.vue?vue&type=script&lang=ts"

import "./NotificationExportPane.vue?vue&type=style&index=0&id=b78d8d90&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b78d8d90"]])

export default __exports__